import { MessageCircle } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { FinalCTA } from "../sections/HomeBlocks2";
import { WhySection, ProcessSection } from "../sections/HomeBlocks";
import { BUSINESS, IMG } from "../data/content";

const CHAPTERS = [
  { n: "01", t: "Why we exist", d: "Small businesses are usually forced to choose: an expensive agency, or a patchwork of freelancers who never talk to each other. BHF Creative was built to be the third option — one small studio that handles both your website and your video ads, with the founder in the conversation from day one." },
  { n: "02", t: "How we work", d: "Everything runs remotely, and most of it runs through WhatsApp. Brief, proposal, previews, revisions, delivery — one thread, no layers. It keeps projects fast, honest and personal, whether you're in Chicago, London, Sydney or Karachi." },
  { n: "03", t: "Where we're going", d: "We're a new studio and we say so plainly. No invented client counts, no fake awards. What we offer instead is care, speed and full attention on every project — because right now, every single client shapes what BHF Creative becomes." },
];

export default function About() {
  return (
    <main>
      <PageHeader
        
        lines={["A remote studio,", "built hands-on."]}
        sub="BHF Creative is a digital studio offering website design and video ad creation for small businesses worldwide — operated entirely remotely."
      />

      <section className="py-16" data-testid="about-manifesto">
        <div className="container-x grid lg:grid-cols-2 gap-16">
          <div className="space-y-14">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div data-testid={`manifesto-chapter-${i}`}>
                  <span className="font-heading font-bold text-5xl grad-text">{c.n}</span>
                  <h2 className="mt-4 mb-4 text-[clamp(22px,2.6vw,32px)]">{c.t}</h2>
                  <p className="text-[#A0A3C2] leading-relaxed m-0">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="space-y-8">
            <Reveal delay={0.2}>
              <div className="rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.08)]">
                <img src={IMG.founder} alt="Founder of BHF Creative in his home studio (optional placeholder portrait)" loading="lazy" className="w-full object-cover" />
              </div>
             <div className="mt-3 text-center">
  <h3 className="text-white font-bold text-base">Hassaan Attari</h3>
  <p className="text-[#A0A3C2] text-xs mt-1">Founder & CEO, BHF Creative</p>
</div>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.08)]">
                <img src={IMG.studio} alt="BHF Creative studio workspace flat lay" loading="lazy" className="w-full object-cover" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <WhySection chapter="04" />
      <ProcessSection chapter="05" />

      <section className="py-20 text-center" data-testid="about-cta">
        <div className="container-x">
          <Reveal>
            <h2>Want to talk it through?</h2>
            <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="about-whatsapp-btn" className="btn btn-wa no-underline mt-7">
              <MessageCircle size={17} /> Chat on WhatsApp
            </a>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
